export default "__VITE_ASSET__Bm_I_Fmy__"